import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

interface LegendItem {
    id: string;
    color: string;
    name: string;
    y: number;
}

interface LegendProps {
    chartData: LegendItem[];
}

export const Legend = ({ chartData }: LegendProps) => {
    return (
        <Stack
            gap="12px"
            flex="1"
            minWidth="0"
            overflow="hidden"
        >
            <Stack
                gap="8px"
                minWidth="0"
            >
                {chartData.map((item) => (
                    <LegendWithOneLineBulletFlex
                        key={item.id}
                        text={item.name}
                        value={`${item.y.toFixed(2)}%`}
                        labelColor={item.color}
                    />
                ))}
            </Stack>
        </Stack>
    );
};
